const s = () => process.env.NODE_ENV === "development", P = () => !!window.__STORYBOOK__, r = () => window.__DEPLOYMENT__ === "stag" || window.__ENVIRONMENT__ === "staging", T = () => window.__DEPLOYMENT__ === "prod", t = () => window.__ENVIRONMENT__ === "production", i = () => window.__ENVIRONMENT__ === "prod-eu", R = () => window.__ENVIRONMENT__ === "prod-sandbox", c = () => !!window.__NAMESPACE__ || !!window.location.origin.match(
  "-stargate-client.prod-sandbox.amplitude.com"
) || !!window.location.origin.match("-audiences.prod-sandbox.amplitude.com"), S = () => ({
  ...window.__AMP_FEATURE_FLAGS__
}), A = (_) => {
  var n, o;
  return (o = (n = window.__AMP_FEATURE_FLAGS__) == null ? void 0 : n[_]) == null ? void 0 : o.value;
}, d = (_) => A(_) === "on", N = () => e("REACT_APP_ENV"), E = {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_ANALYTICS_HOST: process.env.REACT_APP_ANALYTICS_HOST,
  REACT_APP_DASH_HOST: process.env.REACT_APP_DASH_HOST,
  REACT_APP_ENV: process.env.REACT_APP_ENV,
  REACT_APP_LOGOUT_URL: process.env.REACT_APP_LOGOUT_URL,
  REACT_APP_ORBIT_HOST: process.env.REACT_APP_ORBIT_HOST,
  REACT_APP_PUBLIC_BASE_PATH: process.env.REACT_APP_PUBLIC_BASE_PATH,
  REACT_APP_SKYLAB_BACKEND_HOST: process.env.REACT_APP_SKYLAB_BACKEND_HOST,
  REACT_APP_THUNDER_HOST: process.env.REACT_APP_THUNDER_HOST,
  REACT_APP_VERSION: process.env.REACT_APP_VERSION,
  REACT_APP_SESSION_REPLAY_HOST: process.env.REACT_APP_SESSION_REPLAY_HOST
}, e = (_) => {
  var n;
  return ((n = window.env) == null ? void 0 : n[_]) || E[_] || "";
}, O = (_, n) => {
  window.env && (window.env[_] = n), E[_] = n;
};
export {
  S as getAllFlagValues,
  N as getCurrentEnvironment,
  e as getEnv,
  A as getFlagValue,
  s as isDev,
  c as isEphemeralEnv,
  d as isFlagEnabled,
  T as isProd,
  i as isProdEu,
  R as isProdSandbox,
  t as isProdUs,
  r as isStaging,
  P as isStorybook,
  E as processEnv,
  O as setEnv
};
//# sourceMappingURL=env.js.map
